export default __webpack_public_path__ + "static/Plots0001-c9a6b48cacfb11efa6f57030fe2a5d80.jpg";